import { api } from '../api/api'
import { Toast } from '../utils/Toast';

if (localStorage.getItem('user') === 'undefined' || !JSON.parse(localStorage.getItem('user') || '{}')) {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  if (window.location.pathname !== '/' && window.location.pathname !== '/register') {
    window.location.href = '/'
  }
}

function printHtml(html) {
  if (localStorage.getItem('isDesktop') === 'true') {
    if (window.desktopPrinting?.openPreview) {
      window.desktopPrinting.openPreview(html).catch(() => {
        Toast.warning('Não foi possível abrir a prévia de impressão no navegador.')
      })
      return
    }

    const iframe = document.createElement('iframe')
    iframe.title = 'Impressão do pedido'
    iframe.setAttribute('aria-hidden', 'true')
    iframe.style.cssText = 'position:fixed;left:-10000px;top:0;width:800px;height:600px;border:0;'

    let cleanupTimeout
    const cleanup = () => {
      window.clearTimeout(cleanupTimeout)
      iframe.remove()
    }

    iframe.onload = () => {
      const printWindow = iframe.contentWindow

      if (!printWindow) {
        cleanup()
        Toast.warning('Não foi possível abrir a impressão.')
        return
      }

      printWindow.addEventListener('afterprint', cleanup, { once: true })
      cleanupTimeout = window.setTimeout(cleanup, 60000)
      printWindow.focus()
      printWindow.print()
    }

    iframe.srcdoc = html
    document.body.appendChild(iframe)
    return
  }

  const printWindow = window.open('', '', `width=${window.screen.width},height=${window.screen.height}`)

  if (!printWindow) {
    Toast.warning('Permita pop-ups para abrir a impressão.')
    return
  }

  printWindow.document.open()
  printWindow.document.write(html)
  printWindow.document.close()
  printWindow.print()
  printWindow.close()
}

export async function sendPrint(type, data, idOrder) {
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const response = await api.post('/orders/print', {
    type,
    data,
    idOrder,
    isGetHTML: !(user?.isPrint || false)
  })

  if (response.data) {
    printHtml(response.data)
  }
}

export async function sendPrintSafeRegister(id) {
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const isPrint = !(user?.isPrint || false)

  const response = await api.get(`/safe/print/registers/${id}?isGetHTML=${isPrint}`)

  if (response.data) {
    printHtml(response.data)
  }
}

export async function sendPrintSafeClose(id) {
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const isPrint = !(user?.isPrint || false)
  const response = await api.get(`/safe/print/close/${id}?isGetHTML=${isPrint}`)

  if (response.data) {
    printHtml(response.data)
  }
}

export function prepareNotaPrint(codePrint, namePrint) {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const preview = !codePrint || !namePrint || !user?.isPrint
  const desktopPreview = preview && localStorage.getItem('isDesktop') === 'true' && !!window.desktopPrinting?.openPreview
  // Open synchronously so browsers do not block the preview after the request.
  const previewWindow = preview && !desktopPreview ? window.open('', '_blank') : null
  if (preview && !desktopPreview && !previewWindow) {
    Toast.warning('Permita pop-ups para visualizar a nota fiscal.')
  }
  if (previewWindow) {
    previewWindow.opener = null
    previewWindow.document.body.textContent = 'Carregando nota fiscal...'
  }
  return { preview, previewWindow, desktopPreview }
}

export async function sendPrintNota(nota, codePrint, namePrint, prepared) {
  const { preview, previewWindow, desktopPreview } = prepared || prepareNotaPrint(codePrint, namePrint)
  if (preview && !desktopPreview && (!previewWindow || previewWindow.closed)) return
  try {
    const { data } = await api.post('/nfce/print', nota)
    if (!preview) {
      await api.post('/printing', {
        codePrint,
        namePrint,
        body: data.html
      })
      Toast.success('Nota enviada para impressão.')
      return
    }
    if (desktopPreview) {
      await window.desktopPrinting.openPreview(data.html)
      return
    }
    const url = URL.createObjectURL(new Blob([data.html], { type: 'text/html' }))
    previewWindow.location.replace(url)
    window.setTimeout(() => URL.revokeObjectURL(url), 300000)
  } catch (error) {
    previewWindow?.close()
    if (!error?.response?.data?.message) {
      Toast.warning('Não foi possível carregar a nota para impressão. Tente novamente.')
    }
  }
}
